import IconBookSolid from '@/assets/icons/font_awesome/book-solid.svg?react';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { cn } from '@/utils/utils_client';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const ButtonHelpDocs: FC = () => {
  /*
   * FIELDS
   */

  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  /*
   * EVENTS
   */

  async function on_item_selected() {}

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__dropdown_menu_item
      {...{ on_item_selected }}
      value="open_docs"
      class_name_hovered_selected="bg-component-item-selected"
      className={cn('gap-2 p-2 cursor-pointer')}
    >
      <IconBookSolid className="!text-bar-foreground size-5" />
      {t(i18n_base_ui.dropdown.help.button.help_docs.title)}
    </UI_PRIMITIVE__dropdown_menu_item>
  );
};
